import BaseApi from "../BaseApi";


export default class Department extends BaseApi {

    construct() {}

    static getApiUrl() {
        return BaseApi.getApiVersionBasePath("v1") + "departments/";
    }

    static async index(filters = {}) {
        return this.get(this.getApiUrl(), {
            params: filters,
        });
    }

    static async all(filters = {}) {
        return this.index(filters);
    }

    static async search(filters = {}) {
        return this.index(filters);
    }

    static async create(payload) {
        return this.post(this.getApiUrl(), payload);
    }

    static async update(id, payload) {
        return this.patch(this.getApiUrl() + id, payload);
    }

    static async show(id) {
        return this.get(this.getApiUrl() + id);
    }

    static async delete(id) {
        return this.getAxiosInstance().delete(this.getApiUrl() + id);
    }
}
